import shadowRootCss from '../css/shadowRoot.css';

export async function setShadowRootStyling(element?: HTMLElement | null) {
  if (!element) return Promise.reject();
  if (!element.shadowRoot) return Promise.reject();

  const styleElement = document.createElement('style');
  const style = shadowRootCss;
  styleElement.innerHTML = style;

  element.shadowRoot.appendChild(styleElement);

  return Promise.resolve();
}
